if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  const registerXQuantitySelector = () => {
    Alpine.data('xQuantitySelector', (
      productId,
      sectionId,
      qtyRuleMin,
      qtyRuleMax,
      isQtyRule,
      currencyCodeEnable,
      moneyWithCurrency,
      moneyFormat
    ) => ({
      qty: qtyRuleMin,
      min: qtyRuleMin,
      max: qtyRuleMax,
      initQtyChangeEvent(selector) {
        this.$nextTick(() => { 
          this.qty = document.getElementById(selector)?.value;
          document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
            this.qty = e.detail.quantity;
          })
        });
      },
      minus(value) {
        let current = parseInt(this.qty) || this.min;
        if (current - value < this.min) {
          this.qty = this.min;
        } else {
          this.qty = current - value;
        }
        this.updatePrice();
      },
      plus(value) {
        let current = parseInt(this.qty) || this.min;
        if (this.max !== null && this.max !== undefined && current + value > this.max && isQtyRule) {
          this.qty = parseInt(this.max);
        } else {
          this.qty = current + value;
        }
        this.updatePrice();
      },
      invalid(el) {
        let number = parseFloat(el.value);
        if (!Number.isInteger(number) || number < this.min) {
          this.qty = this.min;
        }
        if (this.max !== null && this.max !== undefined && number > this.max && isQtyRule) {
          this.qty = parseInt(this.max);
        }
        this.updatePrice();
      },
      updatePrice() {
        const product_template = document.getElementById(`x-product-template-${productId}-${sectionId}`);
        const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

        const getPrice = (selector) => {
          return Number(product_template.querySelector(selector).innerHTML) * this.qty;
        };
        const update = (selector, value) => {
          const el = product_template.querySelector(selector);
          if (el) el.innerHTML = value;
        };

        let product_price = Alpine.store('xHelper').formatMoney(getPrice('.target-price'), money_format);
        let product_compare_at_price = Alpine.store('xHelper').formatMoney(getPrice('.target-compare-at-price'), money_format);

        update('.add_to_cart_button .main-product-price .price', product_price);
        update('.add_to_cart_button .main-product-price .price-sale', product_price);
        update('.add_to_cart_button .main-product-price .price-compare', product_compare_at_price);
      }
    }));
  };

  if (window.Alpine) {
    registerXQuantitySelector();
  } else {
    document.addEventListener('alpine:init', registerXQuantitySelector);
  }
}